import { useBoolean, useKeyPress } from 'ahooks';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { Flow } from '@/constants/flow';
import { useFlow } from '@/hooks/use-flow';

const label = `Step ${process.env.VITE_BUILD_TIME}`;

export function Stepper() {
  const { flow, setFlow } = useFlow();
  const options = Object.entries(Flow).filter(([key]) => isNaN(Number(key))) as [string, string][];
  const [visible, { toggle }] = useBoolean(true);

  useKeyPress('shift.s', toggle);

  return (
    visible && (
      <Box className="w-280px z-1000 absolute right-4 top-4">
        <FormControl fullWidth>
          <InputLabel id="demo-simple-select-label">{label}</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            value={flow}
            label={label}
            onChange={(e) => {
              setFlow(e.target.value as Flow);
            }}
          >
            {options.map(([key, value]) => (
              <MenuItem key={key} value={value}>
                {key}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    )
  );
}
